import type { ParsedToolCallBase } from "@mirage/mosaics/Chat/components/chat/ConversationMessages/ToolCalls/types";
import * as Runtype from "runtypes";

export const CreateFolderArgs = Runtype.Record({
  folder_path: Runtype.String,
  rationale: Runtype.Optional(Runtype.String),
});
export type CreateFolderArgs = Runtype.Static<typeof CreateFolderArgs>;

export const MoveFilesArgs = Runtype.Record({
  source_paths: Runtype.Array(Runtype.String),
  destination_folder_path: Runtype.String,
  rationale: Runtype.Optional(Runtype.String),
});
export type MoveFilesArgs = Runtype.Static<typeof MoveFilesArgs>;

export const RenameFileArgs = Runtype.Record({
  source_path: Runtype.String,
  new_path: Runtype.String,
  rationale: Runtype.Optional(Runtype.String),
});
export type RenameFileArgs = Runtype.Static<typeof RenameFileArgs>;

export const CopyFilesArgs = Runtype.Record({
  source_paths: Runtype.Array(Runtype.String),
  destination_folder_path: Runtype.String,
  rationale: Runtype.Optional(Runtype.String),
});
export type CopyFilesArgs = Runtype.Static<typeof CopyFilesArgs>;

export const DeleteFilesArgs = Runtype.Record({
  file_paths: Runtype.Array(Runtype.String),
  rationale: Runtype.Optional(Runtype.String),
});
export type DeleteFilesArgs = Runtype.Static<typeof DeleteFilesArgs>;

export type FssOpsToolCall =
  | FssOpsToolCallCreateFolder
  | FssOpsToolCallMoveFiles
  | FssOpsToolCallRenameFile
  | FssOpsToolCallCopyFiles
  | FssOpsToolCallDeleteFiles;

export interface FssOpsToolCallCreateFolder extends ParsedToolCallBase {
  id: string;
  name: "create_folder";
  arguments: CreateFolderArgs;
}

export interface FssOpsToolCallMoveFiles extends ParsedToolCallBase {
  id: string;
  name: "move_files";
  arguments: MoveFilesArgs;
}

export interface FssOpsToolCallRenameFile extends ParsedToolCallBase {
  id: string;
  name: "rename_file";
  arguments: RenameFileArgs;
}

export interface FssOpsToolCallCopyFiles extends ParsedToolCallBase {
  id: string;
  name: "copy_files";
  arguments: CopyFilesArgs;
}

export interface FssOpsToolCallDeleteFiles extends ParsedToolCallBase {
  id: string;
  name: "delete_files";
  arguments: DeleteFilesArgs;
}
